import { RawLocation } from 'vue-router';

enum Events {
  CHANGE = 'change',
}

interface Item {
  after: number | string;
  title: string;
  to?: RawLocation;
}

interface Props {
  items: Items;
  current?: number;
}

type Items = Array<Item>;

export {
  Events,
  Item,
  Items,
  Props,
};



// WEBPACK FOOTER //
// ./src/components/parts/tab/menu/types.ts